import { render, staticRenderFns } from "./AtcTextEditor.vue?vue&type=template&id=289b2de3"
import script from "./AtcTextEditor.vue?vue&type=script&lang=js"
export * from "./AtcTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports